export const PRIORITY_FIELD_OPTIONS = {
  high: { label: 'High', value: 'High' },
  medium: { label: 'Medium', value: 'Medium' },
  low: { label: 'Low', value: 'Low' },
} as const;

// Using variable with type annotation as substitute for satisfies keywork (not
// yet available in version of TypeScript we are using).
/* eslint-disable @typescript-eslint/no-unused-vars */
const typeCheck: Record<string, { label: string; value: string }> =
  PRIORITY_FIELD_OPTIONS;
/* eslint-enable @typescript-eslint/no-unused-vars */
